import { CSS } from '@grupoboticario/flora-react'

export const paginationActionsCss: CSS = {
  flexShrink: 0,
  marginLeft: 2.5
}
